import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryText, navigation } from '../../../styles/colors';
import { BrowserMediaQueries, CssSelectors } from '../../../styles/styles';

const MinBodyInputsWidth = 450;
const MaxBodyInputsWidth = 600;
export const styleSheet = StyleSheet.create({
	body: {
		'@media only screen and (min-height: 1024px)': {
			height: 660,
			maxHeight: 660,
			minHeight: 660,
		},
		'@media only screen and (min-height: 768px)': {
			height: 460,
			maxHeight: 460,
			minHeight: 460,
		},
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		marginTop: 16,
	},
	bodyEditor: {
		flexBasis: 0,
		flexGrow: 1,
		[BrowserMediaQueries.IE11]: {
			// IE11 BS... no position: sticky
			...CssSelectors.allDescendants(
				{
					maxWidth: `${MaxBodyInputsWidth - 2}px`,
					minWidth: MinBodyInputsWidth,
				},
				'.tox.tox-tinymce .tox-editor-container .tox-editor-header'
			),
		},
	},
	bodyInputs: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		flexShrink: 0,
		maxHeight: '100%',
		minWidth: MinBodyInputsWidth,
		position: 'relative',
		...CssSelectors.allDescendants(
			{
				fontSize: 14,
			},
			'input'
		),
		...CssSelectors.allChildren(
			{
				marginTop: 10,
			},
			':not(:first-child)'
		),
	},
	emailAutomationGraphic: {
		display: 'block',
		marginBottom: '1.5rem',
	},
	footer: {
		marginTop: 20,
	},
	headerRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	header: {
		color: brandPrimaryText,
		fontSize: 24,
		margin: 0,
		padding: 0,
	},
	leftContainer: {
		border: '1px solid rgb(202, 224, 236)',
		borderRadius: 3,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		padding: '1rem',
	},
	modalBody: {
		boxSizing: 'border-box',
		display: 'flex',
		height: 'calc(100% - 50px)',
		gap: 16,
	},
	modalContent: {
		backgroundColor: 'white',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		width: '100%',
	},
	modalHeader: {
		alignItems: 'center',
		backgroundColor: brandPrimary,
		display: 'flex',
		flex: '0 0 50px',
		paddingLeft: 20,
		paddingRight: 20,
	},
	modalHeaderTitle: {
		boxSizing: 'border-box',
		color: 'white',
		flex: 1,
		fontSize: 20,
		margin: 0,
		padding: 0,
		textAlign: 'center',
	},
	modalOverlay: {
		height: '100%',
		width: '100%',
	},
	modalRoot: {
		bottom: 0,
		left: 0,
		position: 'fixed',
		right: 0,
		top: 0,
		zIndex: 5,
	},
	rightContainer: {
		display: 'flex',
		flex: '0 1 390px',
		justifyContent: 'center',
		overflow: 'hidden',
	},
	rightContainerPlaceholder: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		paddingTop: '7rem',
	},
	rightInfoText: {
		color: navigation,
		fontSize: '0.75rem',
		textAlign: 'center',
		width: 167,
	},
	saveTemplateModal: {
		...CssSelectors.allDescendants(
			{
				width: 540,
			},
			'.modal-overlay-content'
		),
	},
	attachmentUnionModal: {
		padding: 0,
	},
	attachmentUnionModalContentContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		maxWidth: 400,
		padding: THEME.spacing.md,
	},
	attachmentUnionModalTitle: {
		fontSize: 24,
		color: THEME.colors.primary.main,
		marginBottom: THEME.spacing.md,
	},
	attachmentUnionModalDescription: {
		fontSize: 16,
		color: THEME.colors.text.main,
		textAlign: 'center',
		lineHeight: 1.5,
		marginTop: 0,
		marginBottom: THEME.spacing.lg,
	},
	attachmentUnionModalCloseButton: {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
	attachmentUnionModalCloseButtonIcon: {
		padding: '0 !important',
	},
	attachmentUnionModalContinueButton: {
		width: '100%',
		paddingInline: THEME.spacing.xxxl,
	},
});
